import { useMemo } from 'react';
import { integrationsApi } from 'apis/integrations';
import { customCardIntegrations } from '../../../../utils/useIntegrations/integrations';
const emptyArray = [];
/** A hook that returns all custom cards. */
export const useCustomCards = () => {
    const { data, isFetching, isError } = integrationsApi.useReadCustomCardIntegrationsQuery();
    return {
        isLoading: isFetching,
        customCards: useMemo(() => (data === null || data === void 0 ? void 0 : data.data.custom_cards.map((card) => ({
            cardType: card.integration_type,
            integrationType: 'customCard',
            integrationId: customCardIntegrations[card.integration_type].id,
            description: customCardIntegrations[card.integration_type].description,
            id: card.id,
            label: card.title,
        }))) || emptyArray, [data]),
        isError,
    };
};
